
export default function Partners() {
  const partnerTypes = [
    {
      title: 'Auto Dealers',
      description: 'Franchise and independent dealers looking for reliable inventory sources',
      benefits: ['Consistent inventory flow', 'Competitive pricing', 'Quality assurance', 'Fast turnaround'],
      image: 'https://public.readdy.ai/ai/img_res/20df4adc5e71d80c9891384fc70979b4.jpg'
    },
    {
      title: 'Investors',
      description: 'Financial partners seeking strong returns in the automotive sector',
      benefits: ['Structured investments', 'Market insights', 'Risk management', 'Proven returns'],
      image: 'https://readdy.ai/api/search-image?query=Business%20investors%20analyzing%20automotive%20market%20data%20and%20financial%20reports%20in%20modern%20office%2C%20professional%20meeting%20with%20charts%20and%20graphs%2C%20investment%20strategy%20discussion%2C%20clean%20corporate%20environment%20with%20automotive%20industry%20focus&width=500&height=400&seq=investors&orientation=landscape'
    },
    {
      title: 'Industry Professionals',
      description: 'Automotive professionals and fleet managers across various sectors',
      benefits: ['Industry expertise', 'Custom solutions', 'Network access', 'Professional support'],
      image: 'https://readdy.ai/api/search-image?query=Automotive%20industry%20professionals%20collaborating%20in%20modern%20office%20setting%2C%20team%20meeting%20with%20vehicle%20management%20systems%2C%20professional%20automotive%20consultants%20working%20together%2C%20clean%20business%20environment%20with%20automotive%20technology&width=500&height=400&seq=professionals&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Partners
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We work with diverse partners across the automotive industry to create mutually beneficial relationships
          </p>
        </div>

        <div className="space-y-20">
          {partnerTypes.map((partner, index) => (
            <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <img
                  src={partner.image}
                  alt={partner.title}
                  className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>
              
              <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {partner.title}
                </h3>
                <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                  {partner.description}
                </p>
                
                <div className="grid grid-cols-2 gap-4">
                  {partner.benefits.map((benefit, benefitIndex) => (
                    <div key={benefitIndex} className="flex items-center space-x-3">
                      <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                        <i className="ri-check-line text-green-600 text-sm"></i>
                      </div>
                      <p className="text-gray-700">{benefit}</p>
                    </div>
                  ))}
                </div>
                
                <button className="mt-8 bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
